import React from "react";
import Address from "./common/Address";

const ERC20TokenInfo = ({name, symbol, address}) => {
  if (!address) {
    return null;
  }

  return (
    <>{name} ({symbol}) <Address address={address}/></>
  )
};

export default ERC20TokenInfo;